import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./ActiveVendors.css";
import { useDispatch, useSelector } from "react-redux";
import DynamicFilterBar from "./DynamicFilterBar";

import axios from "axios";
import categoriesData from "../../../../src/data/categoriesData";
import { ShowAllCategories } from "../../../context/Slice/VendorManagementSlice";
import { jwtDecode } from "jwt-decode";

const BackEnd_URL = process.env.REACT_APP_BASE_URL;

function ActiveVendors({ cateName }) {
  const [filteredVendors, setFilteredVendors] = useState([]);
  const [filteredVendorsData, setFilteredVendorData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [filterSelections, setFilterSelections] = useState({});
  const [expandedFilters, setExpandedFilters] = useState({});
  const [isAllExpanded, setIsAllExpanded] = useState(false);
  const [showMoreOptions, setShowMoreOptions] = useState({});
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();

  const [categoryName, setCategoryName] = useState(cateName);
  const [locationName, setLocationName] = useState(null);

  console.log(categoryName);

  const singleSelectionFilters = [
    "SpecialBadges",
    "Languages",
    "Culture",
    "Budget",
    "No. of Days",
    "Total Budget (₹)",
    "Caterer Budget PER PLATE (₹)",
    "Guest Count",
    "DecorBudget(₹)",
    "MakeupBudget",
    "Overall Budget",
    "Capacity",
  ];

  const testcategorie = useSelector((state) => state.VendorManagementR.AllCat);

  console.log(testcategorie);

  useEffect(() => {
    // Dispatch the action
    dispatch(ShowAllCategories())
      .unwrap()
      .then((result) => {
        console.log("Categories fetched successfully:", result);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
      });
  }, [dispatch]);

  const fetchVendors = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${BackEnd_URL}/api/v1/VendorManagement/show-AllVendorService?ServiceName=${categoryName}`
      );
      const vendors = response.data?.data?.allVendorService || [];
      console.log("Vendors fetched:", vendors);

      const filtered = vendors.filter((vendor) => {
        console.log("Checking vendor:", vendor);
        const categoryMatch = categoryName
          ? vendor.Category?.CategorieName?.toLowerCase() ===
            categoryName.toLowerCase()
          : true;
        console.log("Category Match:", categoryMatch);

        const locationMatch = locationName
          ? vendor.City?.toLowerCase() === locationName.toLowerCase()
          : true;
        console.log("Location Match:", locationMatch);

        const currentCategory = testcategorie.filter(
          (category) => category.CategorieName === categoryName
        );

        console.log(currentCategory);

        const parsedFields = JSON.parse(
          currentCategory.CategorieFields || "[]"
        );

        const filterMatch = parsedFields.every(({ fieldName, fieldLabel }) => {
          console.log(fieldName, fieldLabel);
          const selectedOptions = filterSelections[fieldLabel] || [];

          if (!selectedOptions.length) return true; // No filter applied

          if (singleSelectionFilters.includes(fieldLabel)) {
            return selectedOptions[0] === vendor[fieldName];
          }

          return selectedOptions.some((option) =>
            vendor[fieldName]?.includes(option)
          );
        });

        console.log("Filter Match:", filterMatch);

        const statusMatch = vendor.status?.trim().toLowerCase() === "approved";
        console.log("Status Match:", statusMatch);

        return categoryMatch && locationMatch && filterMatch && statusMatch;
      });

      console.log("Filtered Vendors:", filtered);
      setFilteredVendors(filtered);
      setFilteredVendorData(filtered);
    } catch (error) {
      console.error("Error fetching vendors:", error);
      setError("Failed to fetch vendors.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const newCategory = queryParams.get("category");
    const newLocation = queryParams.get("location");

    // Prevent unnecessary re-renders
    if (newCategory !== categoryName || newLocation !== locationName) {
      setCategoryName(newCategory);
      setLocationName(newLocation);
    }
  }, [location.search]);

  const parseImageUrl = (imageData) => {
    try {
      console.log("Parsing Banner Image:", imageData);
      const parsedData = JSON.parse(imageData); // Parse the stringified JSON
      const imagePath = parsedData[0]?.path.replace(/\\/g, "/"); // Ensure the path is properly formatted

      // You need to ensure the path is accessible from the frontend
      const imageUrl = `${BackEnd_URL}/BannerUploads/${imagePath
        .split("/")
        .pop()}`; // Assuming the server serves images from '/BannerUploads'

      console.log("Parsed Image URL:", imageUrl);
      return imageUrl || "assets/dummyProfile.jpg"; // Fallback to a default image
    } catch (err) {
      console.warn("Failed to parse image data. Returning default image.", err);
      return "assets/dummyProfile.jpg"; // Fallback to a default image
    }
  };

  const handleViewDetails = (vendor) => {
    // Get the token from local storage
    const token = localStorage.getItem("token");

    if (token) {
      try {
        // Decode the JWT token
        const decodedToken = jwtDecode(token);

        // Extract the role from the decoded token
        const role = decodedToken.role;

        // Save the role to localStorage
        localStorage.setItem("role", role);
        console.log("Role extracted from token:", role);

        if (vendor.ServiceCategory_ID) {
          localStorage.setItem("ServiceCategory_ID", vendor.ServiceCategory_ID);
          console.log("Stored ServiceCategory_ID:", vendor.ServiceCategory_ID);
        }

        // Check if the role is valid
        const allowedRoles = ["USER", "ADMIN", "VENDOR", "CO-ORDINATOR"];
        if (allowedRoles.includes(role)) {
          navigate(`/vendor-details/${vendor.Vendor_ID}`);
        } else {
          setShowLoginPopup(true); // Show login popup if role is not valid
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        setShowLoginPopup(true); // Show login popup if token is invalid
      }
    } else {
      setShowLoginPopup(true); // Show login popup if no token
    }
  };

  const handleLoginRedirect = () => {
    setShowLoginPopup(false); // Close the popup
    navigate("/login"); // Redirect to the login page
  };

  // const handleFilterChange = (filterLabel, option, isSingleSelection) => {
  //   setFilterSelections((prevSelections) => {
  //     if (isSingleSelection) {
  //       const currentSelections = prevSelections[filterLabel] || [];
  //       // If the option is already selected, deselect it
  //       if (currentSelections[0] === option) {
  //         return { ...prevSelections, [filterLabel]: [] }; // Deselect the option
  //       } else {
  //         return { ...prevSelections, [filterLabel]: [option] }; // Select the new option
  //       }
  //     }

  //     const currentSelections = prevSelections[filterLabel] || [];
  //     const updatedSelections = currentSelections.includes(option)
  //       ? currentSelections.filter((item) => item !== option) // Deselect option
  //       : [...currentSelections, option]; // Select option
  //     return { ...prevSelections, [filterLabel]: updatedSelections };
  //   });
  // };
  // Modified filterData function
  // const filterData = (selections) => {
  //   if (
  //     Object.keys(selections).length === 0 ||
  //     Object.values(selections).every((val) => val.length === 0)
  //   ) {
  //     // Show all data if no filters are applied
  //     setFilteredVendorData(filteredVendorsData);
  //     return;
  //   }

  //   let filteredData = [...filteredVendorsData]; // Start with the original vendor list

  //   Object.keys(selections).forEach((filterKey) => {
  //     if (selections[filterKey].length > 0) {
  //       console.log(
  //         `Applying filter for key: ${filterKey} with values:`,
  //        selections[filterKey]
  //       );

  //       // Handle filtering for DynamicData
  //       if (filterKey !== "SpecialBadges") {
  //         filteredData = filteredData.filter((vendor) => {
  //           const parseAndLogVendor = (vendorData) => {
  //             if (!vendorData) {
  //               console.error(
  //                 "No vendor data available for this vendor:",
  //                 vendor
  //               );
  //               return null;
  //             }
  //             console.log("Vendor DynamicData:", vendorData);
  //             return JSON.parse(vendorData); // Parse dynamic data
  //           };

  //           const VendorDynamicData = parseAndLogVendor(vendor.DynamicData);

  //           if (VendorDynamicData && VendorDynamicData[filterKey]) {
  //             const vendorValue = VendorDynamicData[filterKey];
  //             console.log(
  //               `Checking vendor: ${
  //                 vendor.Name || vendor.id
  //               }, Key: ${filterKey}, Value:`,
  //               vendorValue , typeof vendorValue
  //             );

  //             if (Array.isArray(vendorValue)) {
  //               const match = selections[filterKey].some((selected) =>
  //                 vendorValue.includes(selected)
  //               );
  //               console.log(
  //                 `Array Match for vendor: ${vendor.Name || vendor.id}, Match:`,
  //                 match
  //               );
  //               return match;
  //             } else {
  //               const match = selections[filterKey].includes(vendorValue);
  //               console.log(
  //                 `Direct Match for vendor: ${
  //                   vendor.Name || vendor.id
  //                 }, Match:`,
  //                 match
  //               );
  //               return match;
  //             }
  //           }

  //           console.log(`No match for vendor: ${vendor.Name || vendor.id}`);
  //           return false; // Exclude unmatched vendors
  //         });
  //       } else {
  //         // Handle filtering for SpecialBadges (separate field from DynamicData)
  //         filteredData = filteredData.filter((vendor) => {
  //           console.log(
  //             `Checking SpecialBadges for vendor: ${vendor.Name || vendor.id}`
  //           );

  //           if (vendor.SpecialBadges) {
  //             // Parse the SpecialBadges field (if it's a stringified array)
  //             let badgesArray = [];
  //             try {
  //               badgesArray = JSON.parse(vendor.SpecialBadges);
  //             } catch (error) {
  //               console.error(
  //                 "Error parsing SpecialBadges for vendor:",
  //                 vendor
  //               );
  //             }

  //             // Now filter based on the parsed array
  //             const match = selections[filterKey].some((selectedBadge) =>
  //               badgesArray.includes(selectedBadge)
  //             );
  //             console.log(
  //               `SpecialBadge Match for vendor: ${
  //                 vendor.Name || vendor.id
  //               }, Match:`,
  //               match
  //             );
  //             return match;
  //           }

  //           console.log(
  //             `No match for SpecialBadges for vendor: ${
  //               vendor.Name || vendor.id
  //             }`
  //           );
  //           return false; // Exclude unmatched vendors
  //         });
  //       }

  //       console.log(`Filtered Data after key: ${filterKey}`, filteredData);
  //     }
  //   });

  //   if (filteredData.length === 0) {
  //     console.log("No vendors match the current filters.");
  //     setFilteredVendorData([]); // If no matches, show empty data
  //     return;
  //   }

  //   console.log("Final Filtered Data:", filteredData);
  //   setFilteredVendorData(filteredData);
  // };
  const filterData = (selections) => {
    if (
      Object.keys(selections).length === 0 ||
      Object.values(selections).every((val) => val.length === 0)
    ) {
      // Show all data if no filters are applied
      setFilteredVendorData(filteredVendorsData);
      return;
    }

    let filteredData = [...filteredVendors]; // Start with the original vendor list

    Object.keys(selections).forEach((filterKey) => {
      if (selections[filterKey].length > 0) {
        console.log(
          `Applying filter for key: ${filterKey} with values:`,
          selections[filterKey]
        );

        if (filterKey === "TotalBudget") {
          // **Special Handling for TotalBudget**
          filteredData = filteredData.filter((vendor) => {
            // console.log(
            //   `Checking TotalBudget for vendor: ${vendor.TotalBudget || vendor.id}`
            // );

            if (!vendor.TotalBudget) {
              console.log(
                `Skipping vendor ${
                  vendor.Name || vendor.id
                }, no TotalBudget field.`
              );
              return false;
            }

            let vendorBudgetArray = Array.isArray(vendor.TotalBudget)
              ? []
              : vendor.TotalBudget;
            console.log(vendorBudgetArray);

            const selectedBudgets = selections[filterKey].map((val) =>
              String(val).trim()
            );
            console.log(selectedBudgets);

            const budgetMatch = selectedBudgets.some((selectedBudget) =>
              vendorBudgetArray.includes(selectedBudget)
            );

            console.log(
              `TotalBudget Match for vendor: ${
                vendor.Name || vendor.id
              }, Match:`,
              budgetMatch
            );
            return budgetMatch;
          });
        } else if (filterKey !== "SpecialBadges") {
          // Handle filtering for DynamicData
          filteredData = filteredData.filter((vendor) => {
            const parseAndLogVendor = (vendorData) => {
              if (!vendorData) {
                console.error(
                  "No vendor data available for this vendor:",
                  vendor
                );
                return null;
              }
              console.log("Vendor DynamicData:", vendorData);
              return JSON.parse(vendorData); // Parse dynamic data
            };

            const VendorDynamicData = parseAndLogVendor(vendor.DynamicData);

            if (VendorDynamicData && VendorDynamicData[filterKey]) {
              let vendorValue = VendorDynamicData[filterKey];

              console.log(
                `Checking vendor: ${
                  vendor.Name || vendor.id
                }, Key: ${filterKey}, Value:`,
                vendorValue
              );

              if (Array.isArray(vendorValue)) {
                const match = selections[filterKey].some((selected) =>
                  vendorValue.includes(selected)
                );
                console.log(
                  `Array Match for vendor: ${vendor.Name || vendor.id}, Match:`,
                  match
                );
                return match;
              } else {
                const match = selections[filterKey].includes(vendorValue);
                console.log(
                  `Direct Match for vendor: ${
                    vendor.Name || vendor.id
                  }, Match:`,
                  match
                );
                return match;
              }
            }

            console.log(`No match for vendor: ${vendor.Name || vendor.id}`);
            return false; // Exclude unmatched vendors
          });
        } else {
          // Handle filtering for SpecialBadges (separate field from DynamicData)
          filteredData = filteredData.filter((vendor) => {
            console.log(
              `Checking SpecialBadges for vendor: ${vendor.Name || vendor.id}`
            );

            if (vendor.SpecialBadges) {
              // Parse the SpecialBadges field (if it's a stringified array)
              let badgesArray = [];
              try {
                badgesArray = JSON.parse(vendor.SpecialBadges);
              } catch (error) {
                console.error(
                  "Error parsing SpecialBadges for vendor:",
                  vendor
                );
              }

              // Now filter based on the parsed array
              const match = selections[filterKey].some((selectedBadge) =>
                badgesArray.includes(selectedBadge)
              );
              console.log(
                `SpecialBadge Match for vendor: ${
                  vendor.Name || vendor.id
                }, Match:`,
                match
              );
              return match;
            }

            console.log(
              `No match for SpecialBadges for vendor: ${
                vendor.Name || vendor.id
              }`
            );
            return false; // Exclude unmatched vendors
          });
        }

        console.log(`Filtered Data after key: ${filterKey}`, filteredData);
      }
    });

    if (filteredData.length === 0) {
      console.log("No vendors match the current filters.");
      setFilteredVendorData([]); // If no matches, show empty data
      return;
    }

    console.log("Final Filtered Data:", filteredData);
    setFilteredVendorData(filteredData);
  };

  // Trigger the fetchVendors once when categoryName or locationName changes
  useEffect(() => {
    if (categoryName) fetchVendors();
  }, [categoryName, locationName]);

  console.log(filteredVendorsData);

  const handleFilterChange = (fieldName, selectedValue, isSingleSelection) => {
    setFilterSelections((prevSelections) => {
      const updatedSelections = {
        ...prevSelections,
        [fieldName]: isSingleSelection ? [selectedValue] : selectedValue,
      };

      if (
        Object.values(updatedSelections).every(
          (selection) => selection.length === 0
        )
      ) {
        setFilteredVendorData(filteredVendorsData); // Reset to original vendors
      } else {
        filterData(updatedSelections); // Apply filters
      }

      return updatedSelections;
    });
  };

  console.log(filteredVendorsData);

  const toggleExpandCollapseAllFromFirst = () => {
    const newExpandState = !isAllExpanded;
    setIsAllExpanded(newExpandState);

    const updatedFilters = {};
    categoriesData
      .find((category) => category.name === selectedCategory)
      ?.filters.forEach((filter) => {
        updatedFilters[filter.label] = newExpandState;
      });
    setExpandedFilters(updatedFilters);
  };

  const toggleIndividualFilter = (filterLabel) => {
    setExpandedFilters((prev) => ({
      ...prev,
      [filterLabel]: !prev[filterLabel],
    }));
  };

  const toggleShowMore = (filterLabel) => {
    setShowMoreOptions((prev) => ({
      ...prev,
      [filterLabel]: !prev[filterLabel],
    }));
  };

  const filteredCategories = testcategorie.filter(
    (category) => category.status && category.CategorieName === categoryName
  );
  console.log("Filtered Categories:", filteredCategories); // Debugging line

  const renderNavbar = () => {
    if (!filteredCategories || filteredCategories.length === 0) {
      return null;
    }

    // Assuming filteredCategories contains only one category to show filters for
    const currentCategory = filteredCategories[0];

    // Parse the CategorieFields JSON string
    const categoryFields = JSON.parse(currentCategory.CategorieFields);

    return (
      <div className="navbar">
        <DynamicFilterBar
          categoryFields={categoryFields}
          filterSelections={filterSelections}
          handleFilterChange={handleFilterChange}
          setFilterSelections={setFilterSelections} // Pass setFilterSelections
          setFilteredVendorData={setFilteredVendorData} // Pass setFilteredVendorData
          filteredVendors={filteredVendors} // Pass original unfiltered data
          categoryName={categoryName}
        />
      </div>
    );
  };

  return (
    <div className="active-vendors">
      <div className="row navbar-container">{renderNavbar()}</div>{" "}
      <div className="row  ml-2 " style={{ marginInline: "20px" }}>
        <h2 className="mb-[1px]" style={{ marginTop: "16rem" }}>
          {categoryName || locationName || "Unknown Category"} Vendors
        </h2>
        <div className="row  mt-5">
          {filteredCategories.map((category) => (
            <div className="col-md-6" key={category.id}></div>
          ))}
        </div>
        {loading ? (
          <p className="text-center">Loading vendors...</p>
        ) : error ? (
          <p className="text-center text-danger">{error}</p>
        ) : filteredVendorsData.length > 0 ? (
          <div className="row row-card-container">
            {filteredVendorsData.map((vendor, index) => (
              <div className="col-md-4 card-container" key={index}>
                <div className="card vendor-card">
                  <img
                    src={
                      vendor.BannerImage
                        ? parseImageUrl(vendor.BannerImage)
                        : "assets/dummyProfile.jpg"
                    }
                    className="card-img-top"
                    alt={vendor.ServiceName}
                  />
                  <div className="vendor-card-body">
                    <h5>{vendor.Vendor.firstName}</h5>
                    {/* <p>{"Click to explore!"}</p> */}
                    <div className="vendor-card-info">
                      <span className="vendor-location">
                        <strong>Service Locations:</strong>{" "}
                        {(() => {
                          try {
                            return vendor && vendor.ServiceLocations
                              ? Array.isArray(
                                  JSON.parse(vendor.ServiceLocations)
                                )
                                ? JSON.parse(vendor.ServiceLocations).join(", ")
                                : "Unknown Location"
                              : "Unknown Location";
                          } catch (error) {
                            return "Unknown Location";
                          }
                        })()}
                      </span>

                     

                      <span className="vendor-budget">
  <strong>Budget:</strong>{" "}
  {vendor.ServiceName === "VENUE" || vendor.ServiceName === "WEDDING CATERERS"
    ? JSON.parse(vendor.DynamicData || "{}")["BudgetSlab"] || "N/A"
    : vendor.TotalBudget || "N/A"}
</span>
                    </div>
                    <button
                      className="btn btn-primary"
                      onClick={() => handleViewDetails(vendor)}
                    >
                      View Details
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-center">No vendors available for this category.</p>
        )}
      </div>
      {/* Login Popup */}
      {showLoginPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>To know the vendor details, please do log in first.</p>
            <button className="btn btn-primary" onClick={handleLoginRedirect}>
              Login
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default ActiveVendors;
